import AccessTokenSessionService from "go-security/services/accessTokenSessionService";
import { FileAttachmentApi } from "../../../services/Api/Organization/types";

export const onDownloadAttachment = (fileItem: FileAttachmentApi) => {
	const link = document.createElement("a");
	if (fileItem.url) {
		const token = AccessTokenSessionService.get();
		link.href = `${fileItem.url}?access_token=${token}`;
		link.setAttribute("download", `${fileItem.name}`);
		document.body.appendChild(link);
		link.click();
	} else {
		let bs = atob(fileItem.content);
		let buffer = new ArrayBuffer(bs.length);
		let ba = new Uint8Array(buffer);
		for (let i = 0; i < bs.length; i++) {
			ba[i] = bs.charCodeAt(i);
		}
		let blob = new Blob([ba], { type: fileItem.name.split(".")[1] });
		const url = window.URL.createObjectURL(blob);
		link.href = url;
		link.download = fileItem.name;
		link.click();
	}
};
